<div #downloadModal class="relative z-10 hidden" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 transition-opacity"></div>
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <form [formGroup]="passwordForm" (ngSubmit)="downloadWallet()" class="space-y-6" action="#" method="POST">
          <div>
            <div class="mx-auto flex items-center justify-center">
              <!-- Heroicon name: outline/check -->
              <img src="/assets/images/steps_icons-02.svg" width="200">
            </div>
            <div class="text-left">
              <div class="mt-2">
                <p class="text-sm text-gray-500" i18n>Please enter a password to encrypt and protect your Wallet File.
                  You will need this password to access to your wallet.</p>
                <div class="pt-4">
                  <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
                  <div class="mt-1">
                    <input id="password" name="password" type="password" formControlName="password" required class="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                    <div *ngIf="passwordForm.get('password')?.touched && !passwordForm.get('password').valid">
                      <p class="text-red-500 text-xs">Please enter a password</p>
                    </div>
                  </div>
                </div>

                <div class="pt-0 mt-0 pb-4" style="margin-top: 15px">
                  <label for="repeatPassword" class="block text-sm font-medium text-gray-700">Repeat Password</label>
                  <div class="mt-1">
                    <input id="repeatPassword" name="repeatPassword" formControlName="repeatPassword" type="password" required class="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                    <div *ngIf="passwordForm.get('repeatPassword')?.touched && !passwordForm.get('repeatPassword').valid">
                      <p class="text-red-500 text-xs">Please repeat the password</p>
                    </div>
                    <div *ngIf="passwordForm.get('password')?.touched &&
                                passwordForm.get('repeatPassword')?.touched &&
                                this.passwordForm.invalid &&
                                passwordForm.get('repeatPassword').valid &&
                                passwordForm.errors['mismatch']">
                      <p class="text-red-500 text-xs">Password does not match</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
            <button type="submit"
                    class="inline-flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm">
              Download
            </button>
            <button type="button" (click)="hide()"
                    class="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
